import Logout from '@mui/icons-material/Logout'
import SettingsOutlined from '@mui/icons-material/SettingsOutlined'
import { Avatar, Box, Menu, MenuItem, Typography } from '@mui/material'
import { useQueryClient } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { api } from '../api/client'
import { colorFor, initials } from '../lib/color'

export function AccountMenu({ anchor, onClose, email, placement = 'below' }: { anchor: HTMLElement | null; onClose: () => void; email: string; placement?: 'below' | 'above' }) {
  const navigate = useNavigate()
  const qc = useQueryClient()
  const logout = async () => { await api('/auth/logout', { method: 'POST' }); qc.clear(); navigate('/login', { replace: true }) }
  return (
    <Menu open={Boolean(anchor)} anchorEl={anchor} onClose={onClose}
      anchorOrigin={{ vertical: placement === 'above' ? 'top' : 'bottom', horizontal: 'left' }} transformOrigin={{ vertical: placement === 'above' ? 'bottom' : 'top', horizontal: 'left' }}>
      <Box sx={{ px: 2, py: 1.5, textAlign: 'center' }}><Avatar sx={{ width: 56, height: 56, mx: 'auto', mb: 1, bgcolor: colorFor(email) }}>{initials(null, email)}</Avatar><Typography>{email}</Typography></Box>
      <MenuItem onClick={() => { onClose(); navigate('/settings') }}><SettingsOutlined fontSize="small" sx={{ mr: 1.5 }} />Settings</MenuItem>
      <MenuItem onClick={() => void logout()}><Logout fontSize="small" sx={{ mr: 1.5 }} />Sign out</MenuItem>
    </Menu>
  )
}
